export default __webpack_public_path__ + "static/media/AhmedTayane.f5323ace.webp";